import { User } from 'types/user';
import { FieldValues } from 'common/apps/modules/form/types';

import isUserAffiliate from './isUserAffiliate';
import getUserScheme from './getUserScheme';

const getStripchatScheme = (user: User | FieldValues) =>
  isUserAffiliate(user) ? getUserScheme(user) : null;

export default getStripchatScheme;
